'use client';

import React from 'react'
import Contactus from "../../../assets/Image/home-img/common/Contactus.png";
import rightarrow from "../../../assets/Image/comman/rightarrow.svg"
import Image from 'next/image';
import { useRouter } from 'next/navigation';

export const ContactUs = () => {
  const router = useRouter();

  const textdata = [
    {
      subtitle: "We specialize in creating personalized travel experiences for every budget and style. Reach out to start planning your perfect trip!"
    },
    {
      subtitle: "From luxury getaways to budget-friendly vacations, we make travel seamless. Let’s start planning"
    },
    {
      subtitle: "Got questions? We’re here to help you find the best destinations, deals, and experiences."
    }
  ]

  return (
    <div className='container flex flex-col-reverse lg:flex-row items-center gap-11 justify-center my-16 lg:my-24 overflow-hidden'>
      <div data-aos="fade-right">
        <div className='flex  gap-6'>
          <h6>CONTACT US</h6>

          <Image src={rightarrow} alt='left arrow' />

        </div>
        <div className='flex flex-col gap-2.5'>
          <h2 className='font-bold max-w-[25rem]  pt-3'>Ready to Travel? Let’s Talk!</h2>
          <h3 className='text-dark-gray font-semibold'>“The world is a book and those who do not travel read only one page”</h3>

          {
            textdata.map((i, n) => {
              return (
                <p className='text-dark-gray font-semibold max-w-[35rem]' key={n}>
                  {i.subtitle}</p>
              )
            })
          }
          <button className='btn w-fit' onClick={() => router.push("/contact-us")}>Contact Us</button>
        </div>
      </div>
      <Image src={Contactus} alt='Contactus' className='w-full lg:w-[80%] ' data-aos="fade-left" />



    </div>)
}
